import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { TranslatableString, resolveTranslation } from '../utils/translatable-string';

/**
 * Hook that provides language-aware resolvers for translatable strings.
 *
 * - `rt(value)` — resolves a single TranslatableString to the current language
 * - `rtArray(values)` — resolves an array of TranslatableString values
 *
 * Both handle legacy plain strings and new { en, fr, ar, es } objects.
 */
export function useResolveTranslation() {
  const { i18n } = useTranslation();

  const rt = useCallback(
    (value: TranslatableString | null | undefined): string =>
      resolveTranslation(value, i18n.language),
    [i18n.language],
  );

  const rtArray = useCallback(
    (values: (TranslatableString | null | undefined)[] | null | undefined): string[] =>
      values?.map((v) => resolveTranslation(v, i18n.language)) ?? [],
    [i18n.language],
  );

  return { rt, rtArray };
}
